///Print/ExtraitDeCompte/Frs/2022/01002
import printJS from "print-js";
import { api_URL } from "./Constantes";

export const printFournSoinsComptService = (comptetiers, selectedYear, dateDeb, dateFin) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
    const url = `${api_URL}Print/ExtraitDeCompte/Frs/${selectedYear}/${comptetiers}?dateDeb=${dateDeb}&dateFin=${dateFin}`;
    
    fetch(url, {
      method: 'GET',  
      headers: {
        'user_id': userId,
        'username': username,  
      },
    })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      
      // Utilisez printJS pour imprimer le PDF
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
  };
  export const printFournComptService = (cptegen, selectedYear, dateDeb, dateFin) => {
    const userId = localStorage.getItem('login');
    const username = localStorage.getItem('username');
      const url = `${api_URL}Print/ExtraitDeCompte/FrsAll/${selectedYear}/${cptegen}?dateDeb=${dateDeb}&dateFin=${dateFin}`;
      
      fetch(url, {
        method: 'GET',  
        headers: {
          'user_id': userId,
          'username': username,  
        },
      })
      .then(response => response.blob())
      .then(blob => {
        const file = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        
        // Utilisez printJS pour imprimer le PDF
        printJS(fileURL);
      })
      .catch(error => console.error('Erreur lors de la récupération du PDF', error));
    };